import { Button, Group, Modal, Stack, TextInput } from "@mantine/core";
import { IIssueBoardApi, IIssueViewEnum } from "@schemas/issueBoardSchema";
import { IIssueApi, IIssueGis } from "@schemas/issueSchema";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useAppSelector } from "../../../../hooks";
import { IPostIssue, useCreateIssueMutation } from "../issueRTK";
import { selectIssueBoard } from "../issueSelectors";
import { getIssueRegisterNameOption } from "../issueUtils";

const AddIssueModal: React.FC<{
  isOpen: boolean;
  toggle: () => void;
  onCreateItem: (item: IIssueApi) => void;
  issueBoardId: string;
  gis?: IIssueGis;
  gisImage?: string; // base64
  currentView?: IIssueViewEnum;
}> = ({ isOpen, onCreateItem, toggle, issueBoardId, gis, gisImage, currentView }) => {
  const issueBoard = useSelector(selectIssueBoard);
  return (
    <Modal
      opened={isOpen}
      onClose={toggle}
      yOffset={140}
      size="sm"
      title={getIssueRegisterNameOption(issueBoard?.issueNameSetting, "new")}
    >
      {isOpen && (
        <AddIssueModalContent
          issueBoard={issueBoard}
          toggle={toggle}
          onCreateItem={onCreateItem}
          gis={gis}
          gisImage={gisImage}
          currentView={currentView}
        />
      )}
    </Modal>
  );
};

export default AddIssueModal;

const AddIssueModalContent: React.FC<{
  issueBoard?: IIssueBoardApi;
  toggle: () => void;
  onCreateItem: (item: IIssueApi) => void;
  gis?: IIssueGis;
  gisImage?: string; // base64
  connectedRisikoId?: string;
  currentView?: IIssueViewEnum;
}> = ({ issueBoard, toggle, onCreateItem, gis, gisImage, connectedRisikoId, currentView }) => {
  const [name, setName] = useState("");
  const project = useAppSelector((state) => state.adminReducer.project);
  const [addNewIssue, { isLoading }] = useCreateIssueMutation();

  const add = async () => {
    const input: IPostIssue = {
      projectId: project._id,
      issueBoardId: issueBoard._id,
      issueTitle: name,
      taskOrIssue: "ISSUE",
      issueIdIfItIsATask: null,
      tags: null,
      connectedMeeting: null,
      clientAccess: true,
      gis,
      gisImage: gisImage,
      connectedChecklistItem: null,
      connectedMeetingAgendaItem: null,
      noteboardNode: currentView === "NOTEBOARD" ? { visible: true, x: 200, y: 200 } : undefined,
    };
    const resp = await addNewIssue(input).unwrap();
    onCreateItem(resp);
  };
  const canSubmit = name.trim() !== "" && isLoading !== true;

  return (
    <Stack gap="sm">
      <TextInput
        placeholder={`Skriv inn navn på ${getIssueRegisterNameOption(
          issueBoard?.issueNameSetting,
          "new",
        )?.toLowerCase()}`}
        value={name}
        onChange={(e) => setName(e.target.value)}
        data-autofocus={true}
        onKeyDown={(e) => {
          if (e.key === "Enter" && canSubmit) {
            e.preventDefault();
            void add();
          }
        }}
      />
      <Group justify="space-between">
        <Button variant="outline" onClick={toggle}>
          Avbryt
        </Button>
        <Button disabled={!canSubmit} color="mc-primary" variant="filled" onClick={() => add()}>
          Opprett
        </Button>
      </Group>
    </Stack>
  );
};
